import { render, staticRenderFns } from "./AskQuestion.vue?vue&type=template&id=7590981e&scoped=true&"
import script from "./AskQuestion.vue?vue&type=script&lang=js&"
export * from "./AskQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AskQuestion.vue?vue&type=style&index=0&id=7590981e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7590981e",
  null
  
)

export default component.exports